export default function ReportsPage() {
  return (
    <div className="page-content">
      <div className="mb-8">
        <h1 className="page-title">数据报表</h1>
        <p className="page-subtitle">查看平台数据统计报表</p>
      </div>
      <div className="card">
        <div className="card-body">
          <p className="text-gray-500">数据报表功能开发中...</p>
        </div>
      </div>
    </div>
  )
}